/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconRss: {
  name: 'rss';
  data: string;
} = {
  name: 'rss',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M183.237 504.166c0-41.393-33.556-74.949-74.949-74.949s-74.949 33.556-74.949 74.949 33.556 74.949 74.949 74.949 74.949-33.556 74.949-74.949"/><path d="M395.593 579.116H289.415c0-141.427-114.649-256.077-256.077-256.077V216.861c200.068 0 362.255 162.187 362.255 362.255z"/><path d="M470.542 579.115c0-241.461-195.743-437.204-437.204-437.204V32.61c301.826 0 546.505 244.679 546.505 546.505H470.542z"/></svg>`,
};
